document.addEventListener("DOMContentLoaded", function () {
  var aosConfig = {
    duration: 800,
    once: true,
  };

  AOS.init(aosConfig);

  window.addEventListener("scroll", function () {
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    var heightHeader = document.querySelector(
      ".header-section"
    ).offsetHeight;

    if (scroll >= heightHeader) {
       document.body.classList.add('site-scroll');
    } else {
        document.body.classList.remove('site-scroll');
    }
  });
});
